import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Pipe,
  PipeTransform,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RebatesService } from '../../services/rebates/rebates.service';
import { BrowserService } from '../../services/browser/browser.service';
import { UsersService } from '../../services/users/users.service';
import { CommissionJunctionService } from '../../services/commissionjunction/commissionjunction.service';
import { LocationService } from '../../services/location/location.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { UiAlertService } from '../../services/ui-alert/ui-alert.service';
import { StripeService } from '../../services/stripe/stripe.service';
import { ToastComponent } from '../../components/toast/toast.component';
import { CryptoService } from '../../services/crypto/crypto.service';
import { VendorsService } from '../../services/vendors/vendors.service';
import { Platform } from '@ionic/angular';
import { StorageServiceProvider } from '../../services/storage-service/storage-service';
import { RewardsService } from '../../services/rewards/rewards.service';
import { BrandsService } from '../../services/brands/brands.service';
import { UsersInsuranceService } from '../../services/usersinsurance/users.insurance.service';
import { PurchaseService } from '../../services/purchase/purchase.service';
import { OrdersService } from '../../services/orders/orders.service';
import * as moment from 'moment/moment';

declare var google;

@Component({
  selector: 'app-rebatedetail',
  templateUrl: './rebatedetail.page.html',
  styleUrls: ['./rebatedetail.page.scss'],
})
export class RebatedetailPage implements OnInit, AfterViewInit {

  @ViewChild('locationMapElement', { static: false }) mapElement: ElementRef;
  @ViewChild('descriptionhtml', { static: false }) descriptionElement!: ElementRef;

  PurchaseService = PurchaseService;

  private map;

  private locationChunkSize = 3;
  private locationCount;
  private cloLocations;
  private action;
  private insuranceStateForUserProduct;

  public offer;
  public pageTitle;
  protected preferredOption;
  private offerType;
  protected redeemInfo;
  protected usesMessage;
  protected remaining;
  private userPaymentInfo;
  public productPurchased = false;
  public trigger = false;
  protected notAvailable = false;
  protected activeDate;
  protected terminatedDate;
  protected externalurl;
  protected subscriptionInfo;
  private params;
  private enrollment;
  private enrollState = {};
  private postMetadata: Record<string, any> = {};
  public employerEnrolled = false;
  public planUpgraded = false;

  protected showPopup;
  protected popupTitle;
  protected popupContents;
  protected productInfo = [
  ];

  private returnFromStripe = true;  // always go to home page on back

  // TODO: remove hideOfferButtonsExceptCancel when this moves to just carts
  public hideOfferButtonsExceptCancel = this.brandsService.getUIConfig().hideEnrollButtonForShoppingCart;
  public showShoppingCart = this.brandsService.getUIConfig().shoppingCart;
  public inCurrentOrder = false;
  private clickListenerAdded = false;
  public isProccessingClick = false;

  constructor(
    private route: ActivatedRoute,
    private rebatesService: RebatesService,
    private browserService: BrowserService,
    private usersService: UsersService,
    private locationService: LocationService,
    private router: Router,
    private location: Location,
    private commissionjunctionService: CommissionJunctionService,
    public domSanitizer: DomSanitizer,
    private uiAlertService: UiAlertService,
    private stripeService: StripeService,
    private toastComponent: ToastComponent,
    private cryptoService: CryptoService,
    private vendorsService: VendorsService,
    private platform: Platform,
    private storage: StorageServiceProvider,
    private rewardsService: RewardsService,
    private brandsService: BrandsService,
    private usersInsuranceService: UsersInsuranceService,
    private purchaseService: PurchaseService,
    private storageServiceProvider: StorageServiceProvider,
    private ordersService: OrdersService
  ) {

  }

  ngOnInit() {
    PurchaseService.actionClicked = false;
    this.route.queryParams.subscribe(params => {
      this.loadData();
    });
    this.route.params.subscribe(async params => {
      this.params = params;
      await this.load();
    });
    this.vendorsService.enrollmentChangedObservable.subscribe(info => {
      this.checkIfProductPurchased();
    });
  }

  ngAfterViewInit() {
    if (!this.clickListenerAdded && this.descriptionElement) {
      this.clickListenerAdded = true;
      this.descriptionElement.nativeElement.addEventListener('click', (event: Event) => {
        const target = event.target as HTMLElement;
        if (target.tagName === 'A') {
          const anchor = target as HTMLAnchorElement;
          const href = anchor.getAttribute('href');
          if (!href) return;

          const isExternal = href.startsWith('http://') || href.startsWith('https://');
          event.preventDefault();

          if (isExternal) {
            window.open(href, '_blank');
          } else if (href.startsWith('+')) {
            this.router.navigate(['embeddedpage', this.cryptoService.encodeJSON({ url: href.slice(1) })]);
          }
        }
      });
    }
  }


  private async loadData() {
    switch (this.offerType) {
      case 'access':
        this.offer = this.rebatesService.getRebateDetails(this.params.id);
        const redeemOffer = this.offer._raw.links.redeem_offer['instore_print'];
        this.rebatesService.getOffer(this.params.id).then(offer => {
          this.remaining = offer.offer_uses_remaining;
        });
        this.rebatesService.getAccessContent(redeemOffer ? redeemOffer : this.offer._raw.links.redeem_offer.link).then(result => {
          this.redeemInfo = result.details;
        });
        break;
      case 'groupon':
        this.offer = this.rebatesService.getRebateDetails(this.params.id);
        // this.preferredOption = this.offer._raw.options[this.offer._raw.preferredOfferIndex];
        // this.setupMap();
        break;
      case 'clo':
        this.offer = await this.commissionjunctionService.getCLODetails(this.params.id);
        this.preferredOption = {
          redemptionLocations: this.offer.locations ? this.offer.locations.sort(function (a, b) {
            if (a.position < b.position) { return -1; } if (a.position > b.position) { return 1; } return 0;
          }) : [],
          details: [
            { description: this.offer.description }
          ]
        };
        this.setupMap();
        this.checkIfProductPurchased();
        break;
      case 'cj':
        this.offer = this.commissionjunctionService.getCJRebateDetails(this.params.id);
        break;
    }
  }

  private async load() {
    this.route.params.subscribe(async params => {
      if (params.data) {
        // return from Stripe or ACH setup payment method
        this.returnFromStripe = true;
        this.purchaseService.processPaymentMethod(params);
      }
      this.stripeService.getUserPaymentInfo().then(result => this.userPaymentInfo = result);
      this.offerType = params.type;
      await this.loadData();
      this.storageServiceProvider.set('rewardId', this.offer.id);
      if (this.offer.locationChunkSize) {
        this.locationChunkSize = parseInt(this.offer.locationChunkSize, 10);
      }
      this.locationCount = this.locationChunkSize;
      if (this.offerType === 'groupon') {
        this.cloLocations = this.preferredOption.redemptionLocations.slice(0, this.locationCount);
      }
      this.pageTitle = this.offer.detailPageTitle || 'Offer Detail';

      this.ordersService.getCurrentOrder(this.usersService.getCurrentUserId()).then(order => {
        this.inCurrentOrder = order.status === 'OPEN' && order.items?.includes(this.purchaseButton().action.arguments.vendorProductId) || false;
      });
    });
  }

  async doRefresh(event) {
    await this.loadProductStatus();
    event.target.complete();
  }

  private purchaseButton = () => this.offer?.buttons.find(button => button.action.type === 'wallitStripe' || button.action.type === 'vendor' || button.action.type === 'vendorACH' || button.action.type === 'vendorStripe');

  private loadProductStatus() {
    return this.vendorsService.getProductLaunchMetadata(this.purchaseButton().action.arguments.vendorProductId).then(info => {
      this.productInfo = info.status;
    }).catch(error => {
      // no launch metadata available
    });
  }

  private checkIfProductPurchased() {
    const purchaseButton = this.purchaseButton();
    if (!purchaseButton) {
      return;
    }
    this.usersInsuranceService.getInsuranceStateForUser(this.usersService.getCurrentUserId()).then(insuranceStates => {
      this.insuranceStateForUserProduct = insuranceStates.find(state => state.vendorProductId === purchaseButton.action.arguments.vendorProductId);
      this.trigger = !this.trigger;
    });
    this.vendorsService.getCompanyAndStateForProduct(purchaseButton.action.arguments.vendorProductId).then(result => {
      this.enrollState = result.stateMetadata?.upload || {};
      this.vendorsService.getEnrollment(purchaseButton.action.arguments.vendorProductId).then(result => {
        this.enrollment = result;
        this.trigger = !this.trigger;
      });
    });
    this.vendorsService.getProductState(purchaseButton.action.arguments.vendorProductId).then(state => {
      if (state.info) {
        this.subscriptionInfo = state.info.message;
      }
      if (state.state === 'terminated') {
        this.terminatedDate = state.terminatedDate;
        this.loadProductStatus();
      } else if (state.state === 'post') {
        this.activeDate = state.activeDate;
        this.productPurchased = true;
        this.trigger = !this.trigger;
        this.loadProductStatus();
        this.postMetadata = state?.postMetadata ?? this.postMetadata;
        this.employerEnrolled = this.postMetadata?.args?.employerEnrolled ?? false;
        if (this.employerEnrolled) {
          purchaseButton.action.arguments.employerEnrolled = this.employerEnrolled;
          // Pass along the original postMetadata so we can eventually downgrade if we need
          purchaseButton.action.arguments.basePlanEnrolledMetadata = this.postMetadata;
          if (this.postMetadata?.args?.upload) {
            purchaseButton.action.arguments.plan = this.postMetadata?.args?.upload?.Plan;
            purchaseButton.action.arguments.tier = this.postMetadata?.args?.upload?.Tier;
          } else {
            purchaseButton.action.arguments.plan = this.postMetadata?.args?.plan;
            purchaseButton.action.arguments.tier = this.postMetadata?.args?.tier;
          }
        }
      } else {
        this.vendorsService.getVendorProduct(purchaseButton.action.arguments.vendorProductId).then(vendorProduct => {
          this.stripeService.isProductPurchased(vendorProduct.stripeProductId).then(purchased => {
            this.productPurchased = purchased;
            this.trigger = !this.trigger;
            if (purchased) {
              this.loadProductStatus();
            } else {
              this.vendorsService.getAllVendorProducts().then(allVendorProducts => {
                this.stripeService.getProducts(this.brandsService.getConfigJSON().integration?.stripeProductCompany).then(products => {
                  this.stripeService.getUserPaymentInfo().then(paymentInfo => {
                    this.stripeService.getPurchasedProducts(paymentInfo.stripeCustomerId).then(purchases => {
                      let atLeastOnePurchased = false;
                      products.forEach(product => {
                        const matchedPurchase = purchases.find(purchase => purchase.items.data[0].plan.product === product.id);
                        product.purchased = !!matchedPurchase;
                        if (product.purchased) {
                          atLeastOnePurchased = true;
                        }
                      });
                      if (atLeastOnePurchased) {
                        allVendorProducts.forEach(allVendorProduct => {
                          if (allVendorProduct.stripeProductId !== vendorProduct.stripeProductId && allVendorProduct.vendorSlug === vendorProduct.vendorSlug && allVendorProduct.productName === vendorProduct.productName) {
                            this.notAvailable = true;
                          }
                        });
                      }
                    });
                  });
                }).catch(error => {
                });
              });
            }
          });
        });
      }
    }).catch(error => {
      console.log('ERROR GETTING PRODUCT PURCHASED', error.message);
    });
  }

  private setupMap() {
    const options = {
      center: { lat: this.locationService.defaultLocation.latitude, lng: this.locationService.defaultLocation.longitude },
      zoom: 11,
      streetViewControl: false
    };
    const _this = this;
    if (this.mapElement) {
      setTimeout(() => {
        _this.map = new google.maps.Map(_this.mapElement.nativeElement, options);
        _this.cloLocations.forEach(location => this.addMarker(location));
        _this.showAllLocations();
      }, 250);
    }
  }

  addMarker(location) {
    const latLng = new google.maps.LatLng(parseFloat(location.latitude ? location.latitude : location.lat), parseFloat(location.longitude ? location.longitude : location.lng));
    const markerOptions = {
      position: latLng,
      map: this.map
    };
    const marker = new google.maps.Marker(markerOptions);
    marker.addListener('click', () => {
      const address = `${location.streetAddress1}, ${location.city}, ${location.state} ${location.postalCode}`;
      if ((navigator.platform.indexOf('iPhone') !== -1) ||
        (navigator.platform.indexOf('iPad') !== -1) ||
        (navigator.platform.indexOf('iPod') !== -1)) {
        window.open(`maps://maps.google.com?q=${address}`);
      } else {
        window.open(`https://maps.google.com/maps/place/${address}`);
      }
    });
  }

  getDiscountPercentage() {
    if (this.offer.discount_type === 'percent') {
      return parseFloat(this.offer.discount_value).toFixed(0) + '% Off';
    }
    if (!this.offer.discount_percentage) {
      if (this.getStrikethroughPrice()) {
        const price = parseFloat(this.offer.price);
        const salePrice = parseFloat(this.offer['sale-price']);
        return (100 * (price - salePrice) / price).toFixed(0) + '% Off';
      } else {
        return '';
      }
    }
    const percentage = this.offer.discount_percentage * 100;
    return `${(percentage).toFixed(percentage < 10 ? 1 : 0)}% Off`;
  }

  getDiscountAmount() {
    return this.offerType === 'access' && this.offer.discount_type === 'amount' && parseFloat(this.offer.discount_value) !== 0 ? `$${parseFloat(this.offer.discount_value).toFixed(2)} Off` : '';
  }

  private currency(amount) {
    return parseFloat(amount).toFixed(2);
  }

  getStrikethroughPrice() {
    return this.offer['sale-price'] && this.offer['sale-price'] !== this.offer.price ? ('$' + this.currency(this.offer.price)) : '';
  }

  getCashback() {
    let percentage;
    if (this.offer.cashback_percentage) {
      percentage = this.offer.cashback_percentage;
    } else if (this.offer.cashBackPercentage) {
      percentage = this.offer.cashBackPercentage / 100;
    } else {
      if (this.offerType !== 'cj') {
        return '';
      }
      percentage = this.commissionjunctionService.getDefaultCashBack();
    }
    if (this.offer.price) {
      const cashback = this.offer.price * percentage;
      return cashback === 0 ? '' : `$${(cashback).toFixed(cashback < 10 ? 2 : 0)} Cash Back`;
    } else {
      return percentage === 0 ? '' : `${(percentage * 100).toFixed(percentage < 10 ? 1 : 0)}% Cash Back`;
    }
  }

  getAndWord(offer) {
    return this.getCashback() && this.getDiscountPercentage() ? ' and ' : '';
  }

  getDescription() {
    if (this.offer.details) {
      const template = Handlebars.compile(this.offer.details);
      let productInfoFromBrand;
      if (this.purchaseButton()) {
        productInfoFromBrand = this.brandsService.getConfigJSON().integration?.products?.[this.purchaseButton().action.arguments.vendorProductId];
        this.purchaseButton().action.arguments.products = productInfoFromBrand;
      }
      return this.domSanitizer.bypassSecurityTrustHtml(template({ user: this.usersService.me().user, brand: productInfoFromBrand }));
    }
    return this.domSanitizer.bypassSecurityTrustHtml(this.offerType === 'cj' || this.offerType === 'access' ? this.offer.description : this.preferredOption.details[0].description);
  }

  getImage() {
    return this.offerType === 'access' ? this.offer.image_url : (this.offer._raw ? this.offer._raw.grid4ImageUrl : this.offer['image-url']);
  }

  claimClicked() {
    switch (this.offerType) {
      case 'groupon':
        this.browserService.open(this.offer.url);
        break;
      case 'cj':
        this.browserService.open(this.offer['link'] + '?sid=' + this.usersService.getCurrentUserId());
        break;
      case 'clo':
        this.browserService.open(this.offer['buy-url'] + '?sid=' + this.usersService.getCurrentUserId());
        break;
    }
  }

  getRebateTypeInfo() {
    if (!this.offer.cashBackPercentage || this.offer.cashBackPercentage === '0') {
      return '';
    }
    return this.offerType === 'clo' ? 'Just go to a participating location and use your Wallit-connected debit card.' :
      'Just tap the claim button and pay using your Wallit-connected debit card and receive cash back in addition to the merchant discount.';
  }

  rebateCashback() {
    return 'Online Instant Cash Back';
  }

  rebateDiscount() {
    return 'Discount';
  }

  getLocations() {
    switch (this.offerType) {
      case 'clo':
        return this.cloLocations;
      case 'cj':
        return [];
      case 'groupon':
        return this.preferredOption.redemptionLocations;
      case 'access':
        return [this.offer.merchant];
    }
  }

  showAllLocations() {
    const bounds = new google.maps.LatLngBounds();
    let latLng;
    this.cloLocations.forEach(location => {
      latLng = new google.maps.LatLng(parseFloat(location.latitude ? location.latitude : location.lat), parseFloat(location.longitude ? location.longitude : location.lng));
      bounds.extend(latLng);
    });
    if (this.cloLocations.length < 2) {
      this.map.setCenter(latLng);
      this.map.setZoom(this.offer.map ? parseInt(this.offer.map.zoom, 10) : 11);
    } else {
      this.map.fitBounds(bounds);
    }
  }

  loadMoreClicked() {
    const newLocations = this.preferredOption.redemptionLocations.slice(this.locationCount, this.locationCount + this.locationChunkSize);
    this.locationCount += newLocations.length;
    this.cloLocations = this.cloLocations.concat(newLocations);
    newLocations.forEach(location => this.addMarker(location));
    this.showAllLocations();
  }

  expandLocations() {
    this.router.navigate(['/rebateslocal', this.offer.id], { replaceUrl: true });
  }

  private redeem(type) {
    const redeemOffer = this.offer._raw.links.redeem_offer[type];
    this.rebatesService.getAccessContent(redeemOffer ? redeemOffer : this.offer._raw.links.redeem_offer.link).then(result => {
      this.browserService.open(result.details.link);
    });
  }

  redeemStoreClicked() {
    this.redeem('instore');
  }

  redeemPrintClicked() {
    this.browserService.open(this.redeemInfo.link);
  }

  gotoUrl() {
    this.browserService.open(this.offer['external-url']);
  }

  groupPurchase(action) {
    PurchaseService.actionClicked = false;
    this.usersInsuranceService.getInsuranceProductsForUser(this.usersService.getCurrentUserId()).then(products => {
      if (products.indexOf(action.arguments.vendorProductId) >= 0) {
        this.vendorsService.getVendorProduct(action.arguments.vendorProductId).then(vendorProduct => {
          if (vendorProduct.metadata.selectProductFirst) {
            this.router.navigate(['group-product-choose', this.cryptoService.encodeJSON(Object.assign({}, action, { title: 'Choose your Product' }))]);
          } else {
            this.router.navigate(['/EditProfile/profile/group', this.cryptoService.encodeJSON(action)]);
          }
          this.isProccessingClick = false;
        });
      } else {
        this.toastComponent.presentToast('You are not eligible to purchase this product.');
      }
    });
  }

  doneButtonText() {
  }

  popupDone() {
    this.showPopup = false;
    this.isProccessingClick = false;
    PurchaseService.actionClicked = false;
  }

  leaveDetailPage() {
    if (this.returnFromStripe) {
      this.router.navigate(['/tabs/tab-explore']);
    } else {
      this.location.back();
    }
  }

  async doneClicked(action) {
    this.isProccessingClick = true;
    RewardsService.enrolling = false;
    console.log('DONECLICKED', action);
    if (action.type === 'cancel') {
      this.leaveDetailPage();
      return;
    }
    if (this.notAvailable) {
      this.toastComponent.presentToast('You cannot purchase this product because it is part of a family of products where you have already made a purchase.');
      this.isProccessingClick = false;
      return;
    }

    PurchaseService.actionClicked = true;
    const doEnroll = async () => {
      const vendorProduct = await this.vendorsService.getVendorProduct(action.arguments.vendorProductId);
      return this.purchaseService.doEnroll(vendorProduct, action).then(() => {
        this.isProccessingClick = false;
      });
    };

    this.vendorsService.getVendorProduct(action.arguments.vendorProductId).then(async vendorProduct => {
      let template;
      switch (action.type) {
        case 'popup':
          this.showPopup = true;
          this.popupTitle = action.arguments.popupTitle;
          this.popupContents = action.arguments.content;
          break;
        case 'purchase':
          this.purchaseService.purchaseByQuantity(vendorProduct, action, () => { this.isProccessingClick = false; }, () => { this.isProccessingClick = false; });
          break;
        case 'appurl':
          PurchaseService.actionClicked = false;
          template = Handlebars.compile(action.arguments.url);
          this.router.navigate([template(this.usersService.me())]);
          break;
        case 'externalurl':
          PurchaseService.actionClicked = false;
          template = Handlebars.compile(action.arguments.url);
          const url = template(Object.assign({}, this.usersService.me(), { reward: this.offer }, { platform: this.platform.platforms() }));
          function isSafari() {
            return (
              /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
              /Apple/.test(navigator.vendor)
            );
          }
          if (isSafari()) {
            this.externalurl = url;
          } else {
            window.open(url);
          }
          this.isProccessingClick = false;
          break;
        case 'embedded':
          template = Handlebars.compile(action.arguments.url);
          this.rewardsService.gotoUrl(template(Object.assign({}, this.usersService.me(), {system: {origin: window.location.origin}})), action.arguments.iframe);
          this.isProccessingClick = false;
          break;
        case 'unsubscribeVendor':
          this.vendorsService.cancelProductEnrollment(action.arguments.vendor, action.arguments.product, { arguments: action.arguments }).then(result => {
            this.isProccessingClick = false;
            if (result.error) {
              throw result;
            }
            this.toastComponent.presentToast(`You have unsubscribed from the product`);
          }).catch(error => {
            this.isProccessingClick = false;
            this.toastComponent.presentToast(`Error unsubscribing from product: ${error.error}`);
          });
          break;
        case 'vendorStripe':
        case 'wallitStripe':
        case 'vendorACH':
        case 'group':
          if (this.productPurchased && !(this.employerEnrolled && !this.planUpgraded)) {
            this.rewardsService.afterPurchase(action);
            this.isProccessingClick = false;
          } else {
            if (this.showShoppingCart) {
              action.fromEnrollButton = true;
            }
            if (action.isGroup) {
              this.groupPurchase(action);
            } else {
              this.purchaseService.doPurchase(vendorProduct, action, false, false).then(async result => {
                if (result) {
                  console.log('DOPURCHASECOMPLETED', action);
                  await doEnroll();
                  /*
                  setTimeout(() => {
                    this.router.navigate(['rebatedetail/clo', this.storageServiceProvider.get('rewardId')]);
                  }, 1000);
                   */
                } else {
                  this.isProccessingClick = false;
                }
              });
            }
          }
          break;
        case 'vendor':
          if (this.productPurchased) {
            this.rewardsService.afterPurchase(action);
            this.isProccessingClick = false;
          } else {
            await doEnroll();
          }
      }
    });
  }

  notYetActive() {
    return this.activeDate && moment(this.activeDate).isAfter(moment());
  }

  outsideEnrollmentPeriod() {
    const now = moment();
    const start = this.enrollState['Start Date'] ? moment(this.enrollState['Start Date']) : null;
    const end = this.enrollState['End Date'] ? moment(this.enrollState['End Date']) : null;
    const afterStart = !start || now.isSameOrAfter(start);
    const beforeEnd = !end || now.isSameOrAfter(end);
    if (afterStart && beforeEnd && (start || end)) {
      return '';
    }
    if (moment(this.enrollment?.startDate).isAfter(this.enrollment?.endDate)) {
      return `ERROR: END DATE MUST BE AFTER START`;
    }
    if (this.insuranceStateForUserProduct?.metadata.upload?.['Start Date'] && moment(this.insuranceStateForUserProduct.metadata.upload['Start Date']).isSameOrBefore(moment(), 'day') &&
      this.insuranceStateForUserProduct?.metadata.upload?.['End Date'] && moment(this.insuranceStateForUserProduct.metadata.upload['End Date']).isSameOrAfter(moment(), 'day')
    ) {
      return '';
    }
    if (this.enrollment?.startDate && moment(this.enrollment.startDate).isAfter(moment(), 'day')) {
      return `Enrollment starts ${this.enrollment.startDate}`;
    }
    if (this.enrollment?.endDate && moment(this.enrollment.endDate).isBefore(moment(), 'day')) {
      if (!this.enrollment.reopenDate || moment(this.enrollment.reopenDate).isAfter(moment(), 'day')) {
        return `Enrollment ended ${this.enrollment.endDate}, reopens ${this.enrollment.reopenDate ? moment(this.enrollment.reopenDate).format('M/DD/YY') : moment(this.enrollment.startDate).add(1, 'years').format('M/DD/YY')}`;
      }
    }
    return '';
  }

  disableButton(button) {
    return this.isProccessingClick || ((this.notYetActive() || this.outsideEnrollmentPeriod()) && ((button.action.type === 'vendorACH' || button.action.type === 'vendorStripe' || button.action.type === 'wallitStripe' || button.action.type === 'vendor'))) || (!this.productPurchased && button.enableWhenPurchased);
  }

  buttonTitle(button) {
    return button.title;
  }

  buttonText(button) {
    const isPurchaseButton = (button.action.type === 'vendorACH' || button.action.type === 'vendorStripe' || button.action.type === 'wallitStripe' || button.action.type === 'vendor');
    const cantEnroll = this.outsideEnrollmentPeriod();
    if (cantEnroll && isPurchaseButton) {
      // button.subtitle = `Reopens ${moment(this.enrollment.startDate).add(1, 'years').format('M/DD/YY')}`;
      return cantEnroll;
    }
    if (this.notAvailable && button.action.type === 'vendorStripe') {
      return 'Not Available';
    }
    if (this.productPurchased && isPurchaseButton) {
      if (button.action.hideOnPurchased) {
        button.title = '';
      }
      return this.notYetActive() ? 'Enrolled effective ' + this.activeDate : (button.action.purchased?.title || 'Go to Product');
    }
    return button.title;
  }

  addToCart() {
    const productArguments = { ...this.purchaseButton().action, ...(this.purchaseButton().action.arguments?.products || {})};
    return this.ordersService.addItemActionToCart(
      this.usersService.getCurrentUserId(),
      this.purchaseButton().action.arguments.vendorProductId,
      productArguments,
      true
    ).then((result) => {
      // Could make this more correct by re-getting the order and resetting this.inCurrentOrder as we do in the init,
      // but for simplicity and to minimize additional requests we just set it to be true here
      this.inCurrentOrder = true;
    });
  }

}

@Pipe({
  name: 'buttonText',
  pure: true
})
export class GetButtonTextPipe implements PipeTransform {

  transform(thisArg: RebatedetailPage, button: RebatedetailPage, productPurchased: boolean): SafeHtml {
    return thisArg.buttonText(button);
  }

}

@Pipe({
  name: 'buttonTitle',
  pure: true
})
export class GetButtonTitlePipe implements PipeTransform {

  transform(thisArg: RebatedetailPage, button: RebatedetailPage, productPurchased: boolean): SafeHtml {
    return thisArg.buttonTitle(button);
  }

}

@Pipe({
  name: 'getDescription',
  pure: true
})
export class GetDescriptionPipe implements PipeTransform {

  transform(thisArg: RebatedetailPage): SafeHtml {
    return thisArg.getDescription();
  }

}

@Pipe({
  name: 'getAdvertiserName',
  pure: true
})
export class GetAdvertiserNamePipe implements PipeTransform {

  transform(thisArg: RebatedetailPage): SafeHtml {
    return thisArg.domSanitizer.bypassSecurityTrustHtml(thisArg.offer.merchant ? thisArg.offer.merchant.name : thisArg.offer['advertiser-name']);
  }

}

@Pipe({
  name: 'getTitle',
  pure: true
})
export class GetTitlePipe implements PipeTransform {

  transform(thisArg: RebatedetailPage): SafeHtml {
    return thisArg.domSanitizer.bypassSecurityTrustHtml(thisArg.offer.title);
  }

}
